import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import PageShell from "@/components/Layout/PageShell";
import Seo from "@/components/Seo";
import Logo from "@/components/Logo";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      navigate(loc.state?.from || "/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <PageShell>
      <Seo
        title="Sign in"
        description="Sign in to SparkRead to continue your reading practice, streaks, and SPARX points."
        path="/login"
      />
      <section className="container-spark py-16 lg:py-24">
        <div className="mx-auto max-w-md card-spark p-8" data-testid="login-card">
          <div className="flex flex-col items-center text-center gap-3">
            <Logo variant="auth" as="span" />
            <h1 className="font-display text-xl font-black mb-0">Welcome back</h1>
          </div>
          <p className="mt-2 text-sm text-muted-foreground text-center">Sign in to keep your streak alive.</p>
          <form className="mt-6 space-y-4" onSubmit={submit}>
            <div>
              <label className="text-sm font-semibold" htmlFor="email">Email</label>
              <input
                id="email" type="email" required
                value={email} onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email-input"
                className="mt-1 w-full rounded-2xl border border-input bg-background h-12 px-4 outline-none focus-visible:ring-2 focus-visible:ring-spark-purple"
              />
            </div>
            <div>
              <label className="text-sm font-semibold" htmlFor="password">Password</label>
              <input
                id="password" type="password" required minLength={6}
                value={password} onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password-input"
                className="mt-1 w-full rounded-2xl border border-input bg-background h-12 px-4 outline-none focus-visible:ring-2 focus-visible:ring-spark-purple"
              />
            </div>
            <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="login-submit-btn">
              {busy ? "Signing in..." : "Sign in"}
            </button>
          </form>
          <div className="mt-4 text-sm text-muted-foreground text-center">
            New here? <Link to="/register" state={loc.state} className="text-spark-purple font-semibold">Create an account</Link>
          </div>
          <div className="mt-2 text-xs text-center text-muted-foreground">
            <Link to="/forgot-password" className="text-spark-purple hover:underline" data-testid="forgot-password-link">
              Forgot your password?
            </Link>
          </div>
        </div>
      </section>
    </PageShell>
  );
}
